import { connect } from 'react-redux';
import AdvisorTipsPurchase from './purchase_button';
import { updatePurchaseDetails } from '../../../actions/purchase_details';

interface DispatchProps {
  updatePurchaseDetails: (params: object) => void;
}

interface StateProps {
  purchaseDetails: Purchase.Details,
  currentPaymentSources: object,
  userId: number,
  clientAvailableCredit: string
}

interface ComponentProps {
}

const mapStateToProps = ({
  user: { user },
  purchaseDetails,
  paymentSources: { current }
}: {
  user: { user: User.Details, loading: boolean },
  paymentSources: { current: object },
  purchaseDetails: Purchase.Details,
}): StateProps => ({
  purchaseDetails,
  currentPaymentSources: current,
  userId: user && user.id,
  clientAvailableCredit: user?.clientAvailableCredit
});

export default connect<StateProps, DispatchProps, ComponentProps>(mapStateToProps, {
  updatePurchaseDetails
})(AdvisorTipsPurchase);
